import { API_BASE_URL } from "../../../config";
import React, { useState, useEffect, useCallback } from 'react';

const SellerAssignManager = () => {
    const [assignments, setAssignments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Function to get token from local storage
    const checkToken = useCallback(() => {
        const user = localStorage.getItem('user');
        if (!user) {
            return null;
        }
        return JSON.parse(user)?.token;
    }, []);

    // Fetch all sale location assignments
    const fetchAssignments = useCallback(async () => {
        const token = checkToken();
        if (!token) return;

        try {
            // Feature disabled: /api/Manager/ is no longer usable
            /*
            const response = await fetch(`${API_BASE_URL}/api/Manager/saleLocationAssign/all`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errorText = await response.text();
                setError(`Failed to fetch assignments: ${errorText}`);
                throw new Error(`Failed to fetch assignments: ${errorText}`);
            }

            const data = await response.json();
            setAssignments(data);
            */
           setError('Assignments fetch is currently disabled.');
        } catch (error) {
            setError('Error fetching assignments');
            console.error('Fetch error:', error);
        } finally {
            setLoading(false);
        }
    }, [checkToken]);

    useEffect(() => {
        fetchAssignments();
    }, [fetchAssignments]);

    return (
        <div className="container">
            <h1>Store Location Assignments</h1>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    {error && <p className="error">{error}</p>}
                    <table className="btc-table">
                        <thead>
                        <tr>
                            <th>Store Name</th>
                            <th>Latitude</th>
                            <th>Longitude</th>
                            <th>Assigned To</th>
                        </tr>
                        </thead>
                        <tbody>
                        {assignments.map(assignment => (
                            <tr key={assignment.id}>
                                <td>{assignment.buyer.storeName}</td>
                                <td>{assignment.buyer.latitude}</td>
                                <td>{assignment.buyer.longitude}</td>
                                <td>{assignment.seller.username} : "{assignment.seller.idtype}"</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
};

export default SellerAssignManager;
